import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { useTransferMoneyContext } from '../hooks/useTransferMoneyContext';

interface DeleteAccountParams {
  clientId: string;
  accountId: string;
}

const unlinkAccount = ({ clientId, accountId }: DeleteAccountParams): Promise<string> =>
  authFetch(
    urlWithParams('/Consumer/AchRelationships/Delete', { clientId, relationshipId: accountId }),
    {
      method: 'DELETE',
    },
  );

export const useUnlinkAccountMutation = () => {
  const { managedAccountId } = useTransferMoneyContext();
  const queryClient = useQueryClient();

  return useMutation(unlinkAccount, {
    onSuccess(data, { clientId }) {
      queryClient.invalidateQueries(queryKeys.achRelationships(clientId, managedAccountId));
    },
  });
};
